import { useMemo } from 'react'
import { useRouter } from '@popety_io/popety-io-lib'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'

import {
  estimateSelector,
  estimateLandsSelector,
  poisIsochroneLayersSelector,
} from '../../redux'
import { useAirQualityLayers } from './useAirQualityLayers'
import {
  getMultipleLandLayersOultined,
  getBuildingLayer,
} from './EstimateMap.utils'
import { getDasharrayLayer, getGeoLayers } from './geo.layers'

const useEstimateMapLayers = () => {
  const { query } = useRouter()
  const theme = useTheme()
  const color = theme?.palette?.primary?.main || '#00ade6'

  const estimate: any = useSelector(estimateSelector)
  const { dimension = '3D', egid } = query

  const livabilityIsochrone = useSelector(poisIsochroneLayersSelector)
  const lands = useSelector(estimateLandsSelector)
  const landWithMeters = getGeoLayers(lands?.[0], [], false, color)
  const { airQualityLayers } = useAirQualityLayers()

  const buildingLayer = useMemo(() => {
    return getBuildingLayer(
      estimate,
      query?.energyLayer,
      query?.tab,
      query?.buildingHeight,
      egid,
      estimate?.roofPolygon || [],
      [],
      dimension,
      query?.subTab,
      color,
    )
  }, [
    estimate,
    query?.energyLayer,
    query?.tab,
    query?.subTab,
    query?.buildingHeight,
    dimension,
    egid,
    query?.sunLightTab,
    query?.subTab,
  ])

  const landsLayers: any = useMemo(() => {
    return getMultipleLandLayersOultined(lands, color)
  }, [lands])

  const populationLayers = useMemo(() => {
    return getDasharrayLayer('dasharray-layer', estimate.shareGeojson, color)
  }, [estimate.setShareGeojson])

  const companyLayers = useMemo(() => {
    return getDasharrayLayer(
      'dasharray-layer',
      estimate.companyShareGeojson,
      color,
    )
  }, [estimate.companyShareGeojson])

  const history = [...landsLayers].filter(Boolean)

  const sourcesByPage: Record<string, any[][]> = {
    summary: [landsLayers],
    parcelle: [landWithMeters],
    market: [landsLayers],
    building: [buildingLayer],
    energy: [buildingLayer],
    transaction: history,
    fao: history,
    listing: history,
    livability: [livabilityIsochrone, landsLayers],
    history: [landsLayers],
    airQuality: [landsLayers, airQualityLayers],
    population: [landsLayers, populationLayers],
    company: [landsLayers, ...companyLayers],
  }

  const layers =
    sourcesByPage[query.tab] ||
    sourcesByPage[query.subTab] ||
    sourcesByPage.summary

  const data = layers?.flat()?.filter(Boolean)

  return { data }
}

export { useEstimateMapLayers }
